<template>
  <div class="chat-group-side">
    <!-- 搜索 -->
    <div v-show="!group.quit" class="side-search">
      <el-input placeholder="搜索群成员" v-model="searchText" size="small" prefix-icon="el-icon-search"></el-input>
    </div>

    <div class="side-scroll">
      <!-- 成员区域 -->
      <div v-show="!group.quit" class="side-section">
        <div class="section-title">
          <span>群成员</span>
          <span class="member-count">{{ showMembers.length }}人</span>
        </div>
        <div class="member-grid">
          <div class="member-action" title="邀请好友进群聊" @click="showAddGroupMember = true">
            <div class="action-icon"><i class="el-icon-plus"></i></div>
            <div class="action-text">邀请</div>
            <add-group-member :visible="showAddGroupMember" :groupId="group.id" :members="groupMembers"
              @reload="$emit('reload')" @close="showAddGroupMember = false"></add-group-member>
          </div>
          <div v-if="isOwner" class="member-action" title="选择成员移出群聊" @click="onRemove()">
            <div class="action-icon remove"><i class="el-icon-minus"></i></div>
            <div class="action-text">移除</div>
            <group-member-selector ref="removeSelector" title="选择成员进行移除" :groupId="group.id"
              @complete="onRemoveComplete"></group-member-selector>
          </div>
          <div v-for="(member, idx) in showMembers" :key="member.id">
            <group-member v-if="idx < showMaxIdx" class="member-item" :member="member" :showDel="false"></group-member>
          </div>
        </div>
      </div>

      <!-- 群信息 -->
      <div class="side-section">
        <div class="section-title">群信息</div>
        <div class="info-card">
          <div class="info-row">
            <span class="info-label">群聊名称</span>
            <span class="info-value">{{ group.name }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">群主</span>
            <span class="info-value">{{ ownerName }}</span>
          </div>
          <div class="info-row" v-if="group.notice">
            <span class="info-label">群公告</span>
            <span class="info-value notice">{{ group.notice }}</span>
          </div>
        </div>
      </div>

      <!-- 个人设置 -->
      <div class="side-section">
        <div class="section-title">个人设置</div>
        <div class="info-card">
          <div class="setting-row">
            <span class="info-label">群备注</span>
            <el-input v-model="group.remarkGroupName" :disabled="!editing" maxlength="20" size="small" placeholder="无"></el-input>
          </div>
          <div class="setting-row">
            <span class="info-label">我的昵称</span>
            <el-input v-model="group.remarkNickName" :disabled="!editing" maxlength="20" size="small" placeholder="无"></el-input>
          </div>
          <div class="setting-row" v-if="isOwner">
            <span class="info-label">加群审批</span>
            <el-select v-model="group.joinType" :disabled="!editing" size="small" style="width:100%">
              <el-option :value="0" label="仅邀请"></el-option>
              <el-option :value="1" label="无需审批"></el-option>
              <el-option :value="2" label="需要审批"></el-option>
            </el-select>
          </div>
        </div>
      </div>

      <!-- 操作按钮 -->
      <div v-show="!group.quit" class="side-actions">
        <el-button v-if="editing" type="success" size="small" round @click="onSaveGroup()">保存设置</el-button>
        <el-button v-if="!editing" type="primary" size="small" round @click="editing = !editing">编辑设置</el-button>
        <el-button v-show="!isOwner" type="danger" size="small" round plain @click="onQuit()">退出群聊</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import AddGroupMember from '../group/AddGroupMember.vue';
import GroupMember from '../group/GroupMember.vue';
import GroupMemberSelector from '../group/GroupMemberSelector.vue';

export default {
  name: "chatGroupSide",
  components: {
    AddGroupMember,
    GroupMember,
    GroupMemberSelector,
  },
  data() {
    return {
      searchText: "",
      editing: false,
      showAddGroupMember: false,
      showMaxIdx: 50
    }
  },
  props: {
    group: {
      type: Object
    },
    groupMembers: {
      type: Array
    }
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    loadGroupMembers() {
      this.$http({
        url: `/group/members/${this.group.id}`,
        method: "get"
      }).then((members) => {
        this.groupMembers = members;
      })
    },
    onSaveGroup() {
      let vo = this.group;
      this.$http({
        url: "/group/modify",
        method: "put",
        data: vo
      }).then((group) => {
        this.editing = !this.editing
        this.$store.commit("updateGroup", group);
        this.$emit('reload');
        this.$message.success("修改成功");
      })
    },
    onRemove() {
      // 群主不显示
      let hideIds = [this.group.ownerId];
      this.$refs.removeSelector.open(50, [], [], hideIds);
    },
    onRemoveComplete(members) {
      let userIds = members.map(m => m.userId);
      // 后端接口只支持单个用户踢出，需要逐个调用
      let promises = userIds.map(userId => {
        return this.$http({
          url: `/group/kick/${this.group.id}`,
          method: 'delete',
          params: { userId: userId }
        });
      });
      Promise.all(promises).then(() => {
        this.$emit('reload');
        this.$message.success(`您移除了${userIds.length}位成员`);
      });
    },
    onQuit() {
      this.$confirm('退出群聊后将不再接受群里的消息，确认退出吗？', '确认退出?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        modal: false
      }).then(() => {
        this.$http({
          url: `/group/quit/${this.group.id}`,
          method: 'delete'
        }).then(() => {
          this.$store.commit("removeGroup", this.group.id);
          this.$store.commit("removeGroupChat", this.group.id);
        });
      })
    },
    onScroll(e) {
      const scrollbar = e.target;
      // 滚到底部
      if (scrollbar.scrollTop + scrollbar.clientHeight >= scrollbar.scrollHeight - 30) {
        if (this.showMaxIdx < this.showMembers.length) {
          this.showMaxIdx += 30;
        }
      }
    }
  },
  computed: {
    ownerName() {
      let member = this.groupMembers.find((m) => m.userId == this.group.ownerId);
      return member && member.showNickName;
    },
    isOwner() {
      return this.group.ownerId == this.$store.state.userStore.userInfo.id;
    },
    showMembers() {
      return this.groupMembers.filter((m) => !m.quit && m.showNickName.includes(this.searchText))
    },
    scrollHeight() {
      return Math.min(400, 80 + this.showMembers.length / 5 * 80);
    }
  },
  mounted() {
    let scrollWrap = this.$refs.scrollbar.$el.querySelector('.el-scrollbar__wrap');
    scrollWrap.addEventListener('scroll', this.onScroll);
  }
}
</script>

<style lang="scss" scoped>
.chat-group-side {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
}

.side-search {
  padding: 12px;
  background: #fff;
  border-bottom: 1px solid #eee;
}

.side-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
}

.side-section {
  margin-bottom: 12px;
}

.section-title {
  font-size: 13px;
  font-weight: 600;
  color: #999;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.member-count {
  font-weight: normal;
  font-size: 12px;
  color: #bbb;
}

.member-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  background: #fff;
  border-radius: 8px;
  padding: 12px;
}

.member-action {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50px;
  cursor: pointer;
}

.action-icon {
  width: 38px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  border-radius: 8px;
  border: 1px dashed #ccc;
  color: #999;
  font-size: 16px;
  transition: all 0.2s;
}

.action-icon:hover {
  border-color: #409eff;
  color: #409eff;
}

.action-icon.remove:hover {
  border-color: #f56c6c;
  color: #f56c6c;
}

.action-text {
  font-size: 11px;
  color: #999;
  margin-top: 4px;
}

.member-item {
  margin: 0;
}

.info-card {
  background: #fff;
  border-radius: 8px;
  padding: 4px 0;
  overflow: hidden;
}

.info-row {
  display: flex;
  padding: 10px 14px;
  border-bottom: 1px solid #f8f8f8;
  align-items: flex-start;
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  font-size: 13px;
  color: #999;
  width: 70px;
  flex-shrink: 0;
}

.info-value {
  font-size: 13px;
  color: #333;
  flex: 1;
  word-break: break-all;
}

.info-value.notice {
  white-space: pre-wrap;
  line-height: 1.5;
}

.setting-row {
  display: flex;
  align-items: center;
  padding: 8px 14px;
  border-bottom: 1px solid #f8f8f8;
}

.setting-row:last-child {
  border-bottom: none;
}

.setting-row .info-label {
  margin-right: 10px;
}

.setting-row .el-input, .setting-row .el-select {
  flex: 1;
}

.side-actions {
  text-align: center;
  padding: 16px 0 8px;
  display: flex;
  justify-content: center;
  gap: 10px;
}
</style>
